"use client";
import { SectionPromo } from "@/components/shared/sections/SectionPromo";
import { TranslationsMain } from "@/components/pages/translations/TranslationsMain";
import { BlogPageContext } from "@/helpers/contexts/BlogPageContext";
import "@/styles/critical/_section-promo.scss";
import { PageGradientWrapper } from "@/components/layout/PageGradientWrapper";
import { BlogSearch } from "@/components/pages/blog/search/BlogSearch";
import useTranslationsSearch from "@/helpers/blog/useTranslationsSearch";
import useBlogSearch from "@/helpers/blog/useBlogSearch";

export const TranslationsPage = ({ pagination, breadcrumbsList, notFound, ...props }: any) => {
  const { search, handleSearch } = useBlogSearch();

  return (
    <BlogPageContext.Provider
      value={{
        articles: props.articles,
        categories: props.categories,
        blog: props.blog as any,
        pagination,
        authors: [],
        notFound,
        search,
        clientPagination: pagination,
      }}
    >
      <PageGradientWrapper>
        <SectionPromo
          background="transparent"
          promoWide
          breadcrumbs={breadcrumbsList}
          heading={props.blog.heading}
          subheading={props.blog.description}
        >
          <BlogSearch
            search={search}
            count={pagination.total}
            handleSearch={handleSearch}
            isNotFound={notFound}
          />
        </SectionPromo>
        <TranslationsMain />
      </PageGradientWrapper>
    </BlogPageContext.Provider>
  );
};
